import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import TextField from 'src/components/ui/TextField';

const RangeField = ({
	value: selectedValue,
	onChange: handleSelectedValueChange,
}) => {
	const [value, setValue] = useState(() => {
		if (selectedValue && typeof selectedValue === 'string') {
			const splitted = selectedValue?.split('~');

			return splitted.length === 2 ? splitted : [];
		}

		return [];
	});

	const handleChange = (newValue, variant) => {
		const index = variant === 'first' ? 0 : 1;

		setValue((prev) => {
			const next = [...prev];
			next[index] = newValue;
			return next;
		});
	};

	const getValue = (variant) => {
		const index = variant === 'first' ? 0 : 1;

		return value[index];
	};

	useEffect(() => {
		handleSelectedValueChange(null, value);
	}, [handleSelectedValueChange, value]);

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1}
			divider={<Typography color="secondary">—</Typography>}
		>
			<TextField
				value={getValue('first') || ''}
				onChange={(e) => handleChange(e.target.value, 'first')}
			/>
			<TextField
				value={getValue('second') || ''}
				onChange={(e) => handleChange(e.target.value, 'second')}
			/>
		</Stack>
	);
};

RangeField.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func,
};

export default RangeField;
